import { useMutation, useQueryClient } from "@tanstack/react-query";
import { inviteMember, type InviteMemberDto } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";

export function useInviteMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: InviteMemberDto) => inviteMember(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
